import _ = require("lodash")
import { MessageType } from "../PA.Core/PA.Core.IF.Basic";
import {UIApplicationBO} from "./UIApplicationBO";
import {
    WB_UIAppModuleRow,
} from "../PA.Core/PAdbSchemaRows";
import {CustomerBO} from "../PA.MD.BusinessObjects/CustomerBO";

export class UIApplicationBOValidation {

    static Validation(aBO: UIApplicationBO): Promise<void> {

        return new Promise<void> ((resolve, error) => {
            UIApplicationBOValidation.ValidateStartupPolicy(aBO)
                .then((ignore) => {
                    if(aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0){
                    }
                    resolve()
                    // return;
                    // return UIApplicationBOValidation.ValidateFields(aBO)
                }).catch((err)=>{
                    error()
            })
                // .then((ignore) => {
                //     resolve()
                //     return;
                // })

        })
    }



    static ValidateStartupPolicy(aBO: UIApplicationBO): Promise<void> {
        const self = this;
        let countAutoStart = 0, countAutoStartSearch=0;

        return new Promise((resolve, reject)=>{

            _.forEach(aBO.WB_UIApplication.WB_UIAppModuleRows, (aRow:WB_UIAppModuleRow) => {
                console.log(aRow.cif.STARTUP_POLICY, aBO)
                if(aRow.cif.DELETED_IND !== '1') {
                    if ((aRow.cif.STARTUP_POLICY === "AutoStart" || aRow.cif.STARTUP_POLICY === "AutoStartSearch")) {
                        countAutoStart += 1
                        console.log(aRow, aRow.cif.STARTUP_POLICY)
                    }
                }
            })
            console.log(countAutoStart)
            if(countAutoStart > 1){
                // Log Message
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'startupPolicy',
                        type: MessageType.Error,
                        title: "Only 1 module may be specified as \"Auto Start\" or \"Auto Start Search\", please update module configuration before saving.",
                        description: "",
                        subtitle: "",
                        count: 0
                    })

            }

    else {
                aBO.ValidateMessageProvider.removeMessage('startupPolicy')
            }
            resolve()

        })
    }

}